export const bytesToMiB = (bytes = 0) => {
  if (typeof Number(bytes) !== 'number' || isNaN(bytes) || bytes < 0) {
    return 0;
  }

  return Math.floor(bytes / (1024 * 1024));
};
